<template>
  <v-row>
    <dialog-file-list
      v-on:dialog-file-list-close="onDialogFileListClose"
      :dialog="dialogFileList"
      :company="quotation.company"
      title="Select file for quotation"
      v-if="quotation != null"
    ></dialog-file-list>

    <v-row>
      <v-card flat tile color="white">
        <v-card-title class="primary--text">Required files</v-card-title>

        <v-card-text class="py-0">
          <v-row v-if="quotation.is_dangerous_goods" dense>
            <v-col>
              <v-row no-gutters>
                <v-col>
                  <p>
                    For dangerous goods, you are required to submit a
                    <span>material safety data sheet (MSDS)</span> that corresponds with
                    your cargo before we can book your shipment. To proceed, you may:
                  </p>
                  <ol>
                    <li>Select a previously uploaded MSDS file.</li>
                    <li>Upload a new MSDS file (that will be saved for future use).</li>
                    <li>
                      Proceed with shipment quotation, by selecting this option, you
                      acknowledge that you will be required to upload an MSDS file later.
                    </li>
                  </ol>
                  <p>
                    <b
                      >NOTE: No bookings will be made until all MSDS files are
                      received.</b
                    >
                  </p>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-btn
                  color="primary"
                  dark
                  class="font-weight-bold"
                  style="width: 200px; margin: 10px auto"
                  @click="onDialogFileList"
                >
                  <v-icon left>fa-file-pdf</v-icon>Select from saved files
                </v-btn>
              </v-row>

              <v-row>
                <file-drop-zone
                  v-model="quotation"
                  :file-tags="['MSDS']"
                ></file-drop-zone>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-else dense>
            <v-col>
              <p>
                The designated cargo type does not require any files to proceed with
                booking. Upon confirmation of your booking, we will notify you on the
                required files to be uploaded.
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-row>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      quotation: this.value || null,
      dialogFileList: false,
    };
  },

  watch: {
    value() {
      this.quotation = this.value;
    },
  },

  methods: {
    onDialogFileList() {
      this.dialogFileList = true;
    },

    onDialogFileListClose(selectedFile) {
      if (selectedFile != null) {
        let selectedFileId = selectedFile.file_id;
        let filesList = this.quotation.files;
        let fileExists = false;

        var i;
        for (i = 0; i < filesList.length; i++) {
          if (filesList[i].file_id === selectedFileId) {
            fileExists = true;
            break;
          }
        }

        if (!fileExists) {
          this.quotation.files.push(selectedFile);
        }
      }

      this.dialogFileList = false;
    },
  },
};
</script>

<style></style>
